import React, {ReactElement, useEffect, useState} from 'react';
import {createGlobalStyle} from "styled-components";
import CookieConsent from "./CookieConsent";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
  }
`;

const App = (): ReactElement => {
    const [config, setConfig] = useState<any | null>(null);

    useEffect(() => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(){(window as any).dataLayer.push(arguments);}
        (window as any).gtag = gtag;

        fetch("/cc_configuration.json")
            .then(_ => {
                if(!_.ok) throw new Error(_.statusText)
                return _.text()
            })
            .then(_ => setConfig(JSON.parse(_)))
            .catch(_ => console.error("Cookie Consent Configuration File Not Found", _));
    }, []);

  return (
      <>
        <GlobalStyle/>
          {config && <CookieConsent {...config[document.querySelector("html")?.lang ?? "en"]} />}
      </>
  );
}

export default App;
